/**
 * When modifying this file, consider updating the following files:
 *  - frontend/src/App/fullScreenRoutes.ts
 *  - frontend/src/App/AppRouter.tsx
 *  - frontend/src/PublicApp/Routes.tsx
 *  - e2e/tests/Auth/publicPages.spec.ts
 */
export const ACCEPT_INVITE = '/user-accept-invite';
export const FORGOT_PASSWORD = '/user-forgot-password';
export const RESET_PASSWORD = '/user-reset-password';
export const REACTIVATE_USER = '/user-reactivate';
export const RETURN_TO_APP = '/return_to_mobile_app';
export const RESUME_BUILDER_ROOT_ROUTE = '/jobs/apply';
export const RESUME_BUILDER = '/jobs/apply/:step?';
export const JOIN_LINK = '/join-link';
export const VERIFY_EMAIL_CHANGE = '/verify_email_change';
